
import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineLanguage } from "react-icons/hi2";

function ToggleLanguages() {
  const { i18n } = useTranslation();

  const isEnglish = (
    i18n.resolvedLanguage ||
    i18n.language ||
    "ar"
  )
    .toLowerCase()
    .startsWith("en");

  const changeLanguage = () => {
    i18n.changeLanguage(
      isEnglish ? "ar" : "en"
    );
  };

  return (
    <button
      type="button"
      onClick={changeLanguage}
      aria-label={
        isEnglish
          ? "التغيير إلى العربية"
          : "Switch to English"
      }
      title={
        isEnglish ? "العربية" : "English"
      }
      className="
        group inline-flex h-10
        min-w-[68px] items-center
        justify-center gap-2
        rounded-xl
        border border-skin-border
        bg-skin-soft/70
        px-3
        text-skin-heading
        backdrop-blur-xl
        transition-all duration-200

        hover:border-skin-accent/40
        hover:bg-skin-raised

        focus-visible:outline-none
        focus-visible:ring-2
        focus-visible:ring-skin-accent

        dark:border-white/10
        dark:bg-white/[0.07]
        dark:text-white
        dark:hover:bg-white/[0.12]
      "
    >
      <HiOutlineLanguage
        size={20}
        aria-hidden="true"
        className="text-skin-accent"
      />

      <span className="font-cairo text-sm font-semibold">
        {isEnglish ? "EN" : "AR"}
      </span>
    </button>
  );
}

export default ToggleLanguages;
